/** @format */

import React, { useCallback, useEffect, useState } from 'react';
import { getLocalStorageLng } from 'utils/utils';
import { useHistory } from 'react-router-dom';
import { useModal } from '../../modules/ui';
import {
	PreviewImageWrapper,
	PreviewBodyContainer,
	PreviewTitleWrapper,
	PreviewContentWrapper
} from './styles';
import { getHtmlTag } from 'apis/misc';
import TextEllipsis from 'components/TextEllipsis';

const Link = ({ children, callback, path = 'none', style, type, disabled }) => {
	const [previewData, setPreviewData] = useState({});
	const history = useHistory();
	const { boundToggleRightSidebar } = useModal();
	const { RAZZLE_DOMAIN_URL } = process.env;
	const localizedLang = getLocalStorageLng();
	const isExternal = path.search('http');
	const url =
		isExternal !== -1
			? path
			: `${RAZZLE_DOMAIN_URL}/${localizedLang}/${path === 'none' ? '' : path}`;

	const handleClick = useCallback(
		(e) => {
			e.preventDefault();
			if (disabled) {
				return;
			}
			if (type !== 'mail') {
				boundToggleRightSidebar(false);
				if (callback) {
					callback();
				}
				if (path !== 'none') {
					if (isExternal !== -1) {
						window.location = path;
					} else {
						history.push(`/${localizedLang}/${path}`);
					}
				}
			}
		},
		[callback, path]
	);

	useEffect(() => {
		if (path && type === 'preview') {
			const response = getHtmlTag(path);
			response.then((data) => {
				setPreviewData({
					title: data.ogTitle,
					image: data.ogImage && data.ogImage.url
				});
			});
		}
	}, [setPreviewData]);

	// preview link
	if (type === 'preview') {
		return (
			<div>
				<PreviewImageWrapper src={previewData.image} />
				<PreviewBodyContainer>
					<PreviewTitleWrapper>{path}</PreviewTitleWrapper>
					<PreviewContentWrapper>
						<TextEllipsis lineLimit={2}>
							<a href={path}>{previewData.title}</a>
						</TextEllipsis>
					</PreviewContentWrapper>
				</PreviewBodyContainer>
			</div>
		);
	} else if (type === 'mail') {
		return (
			<a onClick={(e) => handleClick(e)} href={`mailto:${url}`} style={style}>
				{children}
			</a>
		);
	} else {
		return (
			<a onClick={(e) => handleClick(e)} href={url} style={style}>
				{children}
			</a>
		);
	}
};

export default React.memo(Link);
